import { api } from "../../lib/api";

// Fail explicitly if a safety limit is reached; never display a partial month as complete.
export async function loadSocialCalendar(
  start: string,
  end: string,
): Promise<any[]> {
  const posts: any[] = [];
  for (let page = 1; page <= 500; page++) {
    const params = new URLSearchParams({
      start_date: start,
      end_date: end,
      page: String(page),
    });
    const { data } = await api.get<any>(
      `/api/marketing/social-posts/?${params}`,
    );
    if (Array.isArray(data)) return data;
    if (!Array.isArray(data?.results))
      throw new Error("Invalid calendar response");
    posts.push(...data.results);
    if (!data.next) return posts;
  }
  throw new Error(
    "Calendar is too large to load completely. Narrow the date range.",
  );
}
